import { Language } from '../../language/1.0';

const LANGUAGE_LIST: Language[] = [
  { code: 'en-US', label: 'English' },
  { code: 'en-CA', label: 'English' },
  { code: 'en-UK', label: 'English' },

  { code: 'fr-FR', label: 'Français' },
  { code: 'fr-CA', label: 'Français' },

  { code: 'es-ES', label: 'Spanish' },

  { code: 'pr-BR', label: 'Português' },
];

export { LANGUAGE_LIST };
